import React, { useState } from 'react';
import AnalyticsData from '../../Datas/AnalyticsData';
import './AnalyticsDesign.css';
import Card from '../Card/Card';

const AnalyticsDesign = () => {
  const [filterType, setFilterType] = useState('weekly');
  const [selectedMonth, setSelectedMonth] = useState('January');
  const [selectedWeek, setSelectedWeek] = useState('Week 1');

  const getFilteredData = (data, type) => {
    return data.filter(item => {
      if (type === 'monthly') {
        return item.month === selectedMonth;
      } else if (type === 'weekly') {
        return item.week === selectedWeek;
      }
      return true;
    });
  };

  const convertToCSV = (data) => {
    const headers = ['Product', 'Units Sold', 'Price Per Unit', 'Total Sales'];
    let csvContent = headers.join(',') + '\n';
    data.forEach(row => {
      csvContent += `${row.product},${row.unitsSold},${row.pricePerUnit},${row.totalSales}\n`;
    });
    return csvContent;
  };

  const downloadCSV = (data) => {
    const csvContent = convertToCSV(data);
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = 'analytics_data.csv';
    link.click();
  };

  const salesData = getFilteredData(AnalyticsData.sales, filterType);
  const revenueData = getFilteredData(AnalyticsData.revenue, filterType);
  const expenseData = getFilteredData(AnalyticsData.expenses, filterType);

  return (
    <div className="analytics-container">
      <h1>Analytics</h1>
      
      <div className="filters">
        <div>
          <label>Select View: </label>
          <select onChange={(e) => setFilterType(e.target.value)} value={filterType}>
            <option value="monthly">Monthly</option>
            <option value="weekly">Weekly</option>
          </select>
        </div>
        
        {filterType === 'monthly' ? (
          <div>
            <label>Select Month: </label>
            <select onChange={(e) => setSelectedMonth(e.target.value)} value={selectedMonth}>
              <option value="January">January</option>
              <option value="February">February</option>
              <option value="March">March</option>
              <option value="April">April</option>
              <option value="May">May</option>
              <option value="June">June</option>
              <option value="July">July</option>
              <option value="August">August</option>
              <option value="September">September</option>
              <option value="October">October</option>
              <option value="November">November</option>
              <option value="December">December</option>
            </select>
          </div>
        ) : (
          <div>
            <label>Select Week: </label>
            <select onChange={(e) => setSelectedWeek(e.target.value)} value={selectedWeek}>
              <option value="Week 1">Week 1</option>
              <option value="Week 2">Week 2</option>
              <option value="Week 3">Week 3</option>
              <option value="Week 4">Week 4</option>
            </select>
          </div>
        )}
      </div>


      <div className='Cards'>
        <Card />
      </div>

      <div className="sales-table-container table-container">
        <h2>Sales Data</h2>
        <table className="sales-table">
          <thead>
            <tr>
              <th>Product</th>
              <th>Units Sold</th>
              <th>Price Per Unit</th>
              <th>Total Sales</th>
            </tr>
          </thead>
          <tbody>
            {salesData.map((item, index) => (
              <tr key={index}>
                <td>{item.product}</td>
                <td>{item.unitsSold}</td>
                <td>{item.pricePerUnit}</td>
                <td>{item.totalSales}</td>
              </tr>
            ))}
          </tbody>
        </table>
        <button className='button-analytics' onClick={() => downloadCSV(salesData)}>Download Sales Data</button>
      </div>

      <div className="revenue-table-container table-container">
        <h2>Revenue Data</h2>
        <table className="revenue-table">
          <thead>
            <tr>
              <th>Product</th>
              <th>Revenue</th>
            </tr>
          </thead>
          <tbody>
            {revenueData.map((item, index) => (
              <tr key={index}>
                <td>{item.product}</td>
                <td>{item.revenue}</td>
              </tr>
            ))}
          </tbody>
        </table>
        <button className='button-analytics' onClick={() => downloadCSV(revenueData)}>Download Revenue Data</button>
      </div>

      <div className="expenses-table-container table-container">
        <h2>Expense Data</h2>
        <table className="expenses-table">
          <thead>
            <tr>
              <th>Product</th>
              <th>Cost Per Unit</th>
              <th>Total Cost</th>
            </tr>
          </thead>
          <tbody>
            {expenseData.map((item, index) => (
              <tr key={index}>
                <td>{item.product}</td>
                <td>{item.costPerUnit}</td>
                <td>{item.totalCost}</td>
              </tr>
            ))}
          </tbody>
        </table>
        <button className='button-analytics' onClick={() => downloadCSV(expenseData)}>Download Expense Data</button>
      </div>
    </div>
  );
};

export default AnalyticsDesign;
